// @flow

export default async function(): Promise<*> {
  const el = document.querySelector('[data-orders-listing]');

  if (!el) {
    return;
  }

  const module = await import('./index' /* webpackChunkName: "my-orders" */);
  module.default(el);
}



// WEBPACK FOOTER //
// ./src/javascripts/MyOrders/initializer.js